import script from "./PageSectionCollapsible.vue?vue&type=script&setup=true&lang=js"
export * from "./PageSectionCollapsible.vue?vue&type=script&setup=true&lang=js"

import "./PageSectionCollapsible.vue?vue&type=style&index=0&id=264d69b0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.5.13_webpack@5.98.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-264d69b0"]])

export default __exports__